import React, { useEffect, useState } from 'react';

export interface PickableApp {
  id: string;
  name: string;
}

interface Props {
  apps: PickableApp[];
  layerSource: string;
  setLayerSource: Function;
}

export const FulcrumLayer: React.FC<Props> = ({
  apps = [],
  layerSource,
  setLayerSource,
}: Props) => {
  const [selectedOption, setSelectedOption] = useState(layerSource);
  useEffect(() => {
    if (apps.length > 0) {
      setSelectedOption(apps[0].id);
    }
  }, []);

  useEffect(() => {
    if (selectedOption?.length) {
      setLayerSource(selectedOption);
    }
  }, [selectedOption]);

  return (
    <div data-testid="fulcrum-layer" className="layer-type-form">
      <div className="layer-source clearfix">
        <label htmlFor="layer_source" className="required">Select App</label>
        <div className="input">
          <select id="layer_source" name="layer[source]" onChange={(e) => setSelectedOption(e.target.value)} value={selectedOption || ''}>
            {apps.map((appOpt) => (<option key={appOpt.id} value={appOpt.id}>{appOpt.name}</option>))}
          </select>
        </div>
      </div>
    </div>
  );
};
